<template>
  <BasicLink :href="location.href" appearance="dark">
    <InlineAlign gap="small">
      <template #start>
        <SvgIcon icon="location" color="muted" :size="13" />
      </template>
      <template #default>
        <span v-if="hasHtml" v-html="location.title" />
        <span v-else v-text="location.title" />
      </template>
    </InlineAlign>
  </BasicLink>
</template>

<script>
import BasicLink from 'src/components/BasicLink/BasicLink.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import InlineAlign from 'src/components/InlineAlign/InlineAlign.vue';

export default {
  name: 'LocationItem',
  components: { SvgIcon, InlineAlign, BasicLink },
  props: {
    location: {
      type: Object,
      required: true,
    },
    hasHtml: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
